/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_HeadingInputs */

const en_visa_o1_heading = /** @type {(inputs: Visa_O1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Evaluate O-1 Cases`)
};

const pt_visa_o1_heading = /** @type {(inputs: Visa_O1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Avaliamos Casos O-1`)
};

const es_visa_o1_heading = /** @type {(inputs: Visa_O1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Evaluamos Casos O-1`)
};

/**
* | output |
* | --- |
* | "How We Evaluate O-1 Cases" |
*
* @param {Visa_O1_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_heading = /** @type {((inputs?: Visa_O1_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_heading(inputs)
	if (locale === "es") return es_visa_o1_heading(inputs)
	return en_visa_o1_heading(inputs)
});